import { Grid, List } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";
import OverlaySpinner from "../../../common/components/functional/overlaySpinner/OverlaySpinner";
import CardsList from "../CardsList";
import { selectCustomerOrganizationById } from "../customerOrganizationsSlice";
import {
  fetchWorkLocationsAndContractsByOrgId,
  selectAllCustomerContracts,
  selectAllCustomerWorkLocations,
} from "../customerWorkLocationsSlice";
import { ModalState } from "../types/types";
import WhiteCard from "../WhiteCard";
import { TalentPoolInfo } from "./TalentPoolInfo";

export const PoolsTab = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const customerOrgId = searchParams.get("org");
  const status = useAppSelector((state) => state.customerWorkLocations.status);
  const isLoading = status === "pending";

  const [modalState, setModalState] = useState<ModalState>({
    show: false,
    id: "",
  });

  const selectedOrganization = useAppSelector((state) =>
    selectCustomerOrganizationById(state, customerOrgId as string),
  );

  const workLocations = useAppSelector((state) =>
    selectAllCustomerWorkLocations(state),
  );

  const contracts = useAppSelector((state) =>
    selectAllCustomerContracts(state),
  );

  const workLocationsList = workLocations.map((workLocation) => {
    const contractByWorkLocationContractId = contracts.find(
      (contract) => contract.id === workLocation?.contractId,
    );

    return {
      name: workLocation.name,
      active: workLocation.active,
      contract: contractByWorkLocationContractId?.name,
      id: workLocation.id,
    };
  });

  const workLocationItems = workLocationsList
    .filter((workLocation) => workLocation.active)
    .sort((a, b) => a.name.localeCompare(b.name));

  useEffect(() => {
    if (selectedOrganization) {
      dispatch(
        fetchWorkLocationsAndContractsByOrgId({ id: selectedOrganization.id }),
      );
    }
  }, [dispatch, selectedOrganization]);

  const onOpen = (workLocationId?: string) =>
    setModalState({ show: true, id: workLocationId });

  const onClose = () => {
    setModalState({ show: false, id: "" });
  };

  return (
    <Grid container flexDirection="column" pt={2}>
      <OverlaySpinner isLoading={isLoading} />
      <CardsList>
        <List disablePadding>
          {workLocationItems.map((workLocation) => (
            <WhiteCard
              key={workLocation.id}
              onClick={() => onOpen(workLocation.id)}
              primary={workLocation.name}
              secondary={workLocation.contract}
              active={workLocation.active}
            />
          ))}
        </List>
      </CardsList>
      <DialogComponent
        variant="card"
        open={modalState.show}
        sx={{ minWidth: "857px" }}
      >
        <TalentPoolInfo workLocationId={modalState.id} onClose={onClose} />
      </DialogComponent>
    </Grid>
  );
};
